import { forwardRef } from 'react';
import { IStopArea } from '../../../../../../../models/stop-area.model';
import { t } from '../../../../../../../services/texts.service';
import { Icon } from '../../../../../../Shared/Icon';
import { IconMotif } from '../../../../../../Shared/Icon/icon-motif.enum';
import { StopAreaType } from '../../../../models/stop-area-type.enum';
import StopAreaDescription from '../StopAreaDescription';

export default forwardRef(function StopAreaButton(
  {
    stopAreas,
    type,
    isSelected,
    isExpanded,
    onKeyDown,
    onClick,
  }: {
    stopAreas: IStopArea[];
    type: StopAreaType;
    isSelected: boolean;
    isExpanded: boolean;
    onKeyDown?: (e: React.KeyboardEvent<HTMLButtonElement>) => void;
    onClick?: () => void;
  },
  ref: React.Ref<HTMLButtonElement>,
) {
  const homeLabel = t('Hemma', 'Home');
  const workLabel = t('Arbete', 'Work');
  const typeLabel = type === StopAreaType.Home ? homeLabel : workLabel;
  const actionLabel = isExpanded ? t('Stäng meny', 'Close menu') : t('Öppna meny', 'Open menu');
  const stopAreaNames = stopAreas.map((stopArea) => stopArea.name).join(', ');

  let ariaLabel: string;
  if (isSelected) {
    ariaLabel = !isExpanded
      ? `${t('Valda hållplatser', 'Selected stop areas')}: ${typeLabel}, ${stopAreaNames}. ${actionLabel}.`
      : `${t('Valda hållplatser', 'Selected stop areas')}: ${typeLabel}, ${stopAreaNames}.`;
  } else {
    ariaLabel = `${t('Välj hållplatser', 'Select stop areas')}: ${typeLabel}, ${stopAreaNames}`;
  }

  return (
    <button
      id={`stop-area-${type}`}
      ref={ref as React.Ref<HTMLButtonElement>}
      className={`stop-area-selector__stop-area ${isSelected ? 'stop-area-selector__stop-area--selected' : ''} btn--unstyled rounded p-2 p-sm-3 w-100 d-flex flex-column text-start`.trimEnd()}
      aria-label={ariaLabel}
      aria-expanded={isSelected ? isExpanded : undefined}
      aria-controls={isSelected ? 'stop-area-selector' : undefined}
      onKeyDown={onKeyDown}
      onClick={onClick}
    >
      <div className="d-flex align-items-center gap-2 w-100 justify-content-between">
        <StopAreaDescription stopAreas={stopAreas} type={type} />
        {isSelected && <Icon motif={isExpanded ? IconMotif.ChevronUp : IconMotif.ChevronDown} altText="" />}
      </div>
    </button>
  );
});
